<div class="busy-indicator-container">
    <div class="busy-loading-header">{{Header}}</div>
    <div class="busy-indicator-body">
        <div class="busy-loading-lines"></div>
        <div class="busy-indicator-loading-container">				
            <div class="busy-loading-circle">
                <div class="busy-indicator-loading-container busy-indicator-loading-padding">
                    <svg viewBox="0 0 140 140">
                        <g>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-1" 
                            d="M46,3l21.7,12.5v25L46,53L24.3,40.5v-25L46,3z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-2" 
                            d="M94,3l21.7,12.5v25L94,53L72.3,40.5v-25L94,3z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-6" 
                            d="M22.8,45l21.7,12.5v25L22.8,95L1.1,82.5v-25L22.8,45z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-7" 
                            d="M69.8,45l21.7,12.5v25L69.8,95L48.1,82.5v-25L69.8,45z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-3" 
                            d="M116.8,45l21.7,12.5v25L116.8,95L95.1,82.5v-25L116.8,45z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-5" 
                            d="M46,86l21.7,12.5v25L46,136l-21.7-12.5v-25L46,86z"></path>
                            <path class="busy-indicator-loading-hexagon busy-indicator-hexagon-4" 
                            d="M94,86l21.7,12.5v25L94,136l-21.7-12.5v-25L94,86z"></path>
                        </g>
                    </svg>
                </div>
            </div>
        </div>
        
        <div class="busy-loading-lines"></div>
    </div>
    <div class="busy-loading-content">{{BusyMessage}}</div>
</div>



// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/busy-indicator/busy-indicator-overlay/busy-indicator-overlay.html